import {Box} from "@mui/system";
import {Typography} from "@mui/material";
import {ListDivider} from "../../../ui/ListStyles";
import {COLORS} from "../../../ui/Theme";

export const CustomTooltip = ({active, payload, keysToShow}) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;

        return (
            <Box
                sx={{
                    backgroundColor: COLORS.SOFTBLUE,
                    padding: "10px",
                    borderRadius: "8px",
                    color: "#FFFFFF",
                    textAlign: "center",
                }}
            >
                {data.date && (
                    <Typography sx={{fontSize: "12px", fontWeight: 700, color: COLORS.BLACK}}>
                        {data.date}
                    </Typography>
                )}
                <ListDivider/>
                {keysToShow.includes("strike") && data.strike && (
                    <Typography sx={{fontSize: "12px", fontWeight: 400, color: COLORS.ORANGE}}>
                        <span>قیمت اعمال: </span>
                        <span style={{fontWeight: 900}}>
                            {new Intl.NumberFormat("fa-IR").format(data.strike)}
                        </span>
                    </Typography>
                )}
                {keysToShow.includes("premium_strike") && data.premium_strike && (
                    <Typography sx={{fontSize: "12px", fontWeight: 400, color: COLORS.BLUE}}>
                        <span>پرمیوم + قیمت اعمال: </span>
                        <span style={{fontWeight: 900}}>
                            {new Intl.NumberFormat("fa-IR").format(data.premium_strike)}
                        </span>
                    </Typography>
                )}
                {keysToShow.includes("equit_close_price") && data.equit_close_price && (
                    <Typography sx={{fontSize: "12px", fontWeight: 400, color: COLORS.RED}}>
                        <span>قیمت پایانی سهم: </span>
                        <span style={{fontWeight: 900}}>
                            {new Intl.NumberFormat("fa-IR").format(data.equit_close_price)}
                        </span>
                    </Typography>
                )}
                {keysToShow.includes("volume") && (
                    <Typography sx={{fontSize: "12px", fontWeight: 400, color: COLORS.BLUE}}>
                        <span>حجم: </span>
                        <span style={{fontWeight: 900}}>
                            {new Intl.NumberFormat("fa-IR").format(data.volume)}
                        </span>
                    </Typography>
                )}
            </Box>
        );
    }

    return null;
};
